export type FormValues = Record<string, string | boolean>;

export interface Input {
    name: string;
    type: InputValidationType;
    required: boolean;
}

export const enum InputValidationType {
    REQUIRED = 'required',
    TEXT = 'text',
    NUMBER = 'number',
    PHONE = 'phone',
    PHONE_V2 = 'phoneV2',
    EMAIL = 'email',
    URL = 'url',
    TEXTAREA = 'textarea',
    BIRTHDAY = 'birthday',
}
